import React, { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { profile1 } from '../../images'
import Facts from './Facts'
import "./Header.css"

// Register GSAP plugin at module level (not inside render)
gsap.registerPlugin(useGSAP)

const Header = () => {
  const container = useRef();

  useGSAP(() => {
    gsap.fromTo(".profile__photo__container", {
      scale: 0.5,
      duration: 1,
      opacity: 0.5,
    },
      {
        scale: 1,
        duration: 1,
        ease: "sine.in",
        opacity: 1,
      })
    gsap.from('.intro__text', {
      fontSize: 100,
      duration: 1,
      delay: 1,
      ease: "sine.in",
    })
    const timeline = gsap.timeline();
    timeline
      .from(".header__info__top", {
        opacity: 0,
      })
      .from(".header__title", {
        opacity: 0,
        y: -30,
      })
      .from(".header__description", {
        opacity: 0,
      })
      .from(".btn", {
        x: -40,
        opacity: 0,
        stagger: .5,
      })
  }, { scope: container });
  return (
    <header id="header" className='blur-effect' ref={container}>
      <div className="stroke__text intro__text">Ragnar</div>
      <div className="section__wrapper header__container">
        <div className="column intro__container blur-effect">
          <div className="header__info">
            <div className="header__info__top">
              <span className="color__primary">App Developer • Web Builder • Community Creator</span>
            </div>
            <div className="header__info__middle">
              <h1 className="primary__title header__title">Hi, I'm Ragnar</h1>
              <p className="header__description text__muted">
                I build Android apps, web platforms, and tech communities that serve thousands of users. From network diagnostics to privacy-focused email — I ship products that solve real problems.
              </p>
            </div>
            <Facts />

          </div>
        </div>
        <div className="column profile__wrapper">
          <div className="profile__photo__container">
            <img src={profile1} alt="Ragnar - App Developer" className='profile__photo' />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header

